import type {
  AdminFundUpdateEntry,
  CmsBlock,
  FundUpdateEntry,
} from '../../../models/FundUpdateEntry';
import { mergeFundUpdatesAsPublished } from './mergeFundUpdatesAsPublished';

export interface FundUpdatesAdminService {
  getAdminFundUpdates(fundOpportunityId: string): Promise<AdminFundUpdateEntry[]>;
  getFundOpportunityContent(
    type: 'FundUpdate',
    updateId: string,
    draft: boolean,
  ): Promise<string | null>;
}

/**
 * Fetches the fund's updates fresh from the admin API, including each draft's latest saved
 * content, and returns them as investors would see them after "Publish All".
 */
export async function loadFundUpdatesAsPublished(
  service: FundUpdatesAdminService,
  fundOpportunityId: string,
): Promise<FundUpdateEntry[]> {
  const updates = await service.getAdminFundUpdates(fundOpportunityId);
  const drafts = updates.filter((update) => update.status === 'draft');
  const published = updates.filter((update) => update.status === 'published');

  const loadDraftContent = async (updateId: string): Promise<CmsBlock[] | null> => {
    const raw = await service.getFundOpportunityContent('FundUpdate', updateId, true);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { content?: CmsBlock[] };
    return Array.isArray(parsed.content) ? parsed.content : null;
  };

  return mergeFundUpdatesAsPublished(published, drafts, loadDraftContent);
}
